import { render, staticRenderFns } from "./TopOnlyLayout.vue?vue&type=template&id=af91e42a&scoped=true"
import script from "./TopOnlyLayout.vue?vue&type=script&lang=js"
export * from "./TopOnlyLayout.vue?vue&type=script&lang=js"
import style0 from "./TopOnlyLayout.vue?vue&type=style&index=0&id=af91e42a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af91e42a",
  null
  
)

export default component.exports